/* NoWa theme runtime — replaces the design-tool framework with vanilla JS. */
(function () {
  'use strict';

  var NW = window.NoWa || {};
  var routes = NW.routes || {};
  var $ = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };

  /* ------------------------------------------------------------------ money */
  function money(cents) {
    var fmt = NW.moneyFormat || '£{{amount}}';
    function fmtNum(c, dec, thou, places) {
      if (isNaN(c) || c === null) c = 0;
      c = (c / 100).toFixed(places);
      var parts = c.split('.');
      var i = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + (thou || ','));
      return places > 0 ? i + (dec || '.') + parts[1] : i;
    }
    return fmt.replace(/\{\{\s*(\w+)\s*\}\}/g, function (_, name) {
      switch (name) {
        case 'amount': return fmtNum(cents, '.', ',', 2);
        case 'amount_no_decimals': return fmtNum(cents, '.', ',', 0);
        case 'amount_with_comma_separator': return fmtNum(cents, ',', '.', 2);
        case 'amount_no_decimals_with_comma_separator': return fmtNum(cents, ',', '.', 0);
        case 'amount_with_space_separator': return fmtNum(cents, ',', ' ', 2);
        default: return fmtNum(cents, '.', ',', 2);
      }
    });
  }

  /* ------------------------------------------------------------- announcement */
  function announcement() {
    var bar = $('[data-nw-announcement]');
    if (!bar) return;
    var track = $('[data-nw-ann-track]', bar);
    if (!track) return;
    var items = track.children.length;
    if (items < 2) return;
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    var i = 0, h = track.children[0].offsetHeight || 20;
    setInterval(function () {
      i = (i + 1) % items;
      track.style.transform = 'translateY(' + (-i * h) + 'px)';
    }, 4000);
  }

  /* -------------------------------------------------------------------- nav */
  function nav() {
    var header = $('[data-nw-header]');
    if (!header) return;

    // mobile menu
    on('menu:toggle', function (el) {
      var open = header.classList.toggle('is-menu-open');
      el.setAttribute('aria-expanded', open ? 'true' : 'false');
      var mob = $('[data-nw-mobilenav]', header);
      if (mob) mob.hidden = !open;
      document.body.style.overflow = open ? 'hidden' : '';
    });

    // desktop mega menu — one panel shared by the header, as in the design
    var mega = $('[data-nw-mega]', header);
    if (mega) {
      var openMega = function (link) {
        mega.hidden = false;
        header.classList.add('is-nav-open');
        if (link) link.setAttribute('aria-expanded', 'true');
      };
      var closeMega = function () {
        mega.hidden = true;
        header.classList.remove('is-nav-open');
        $$('.nw-nav__link[aria-haspopup]', header).forEach(function (l) {
          l.setAttribute('aria-expanded', 'false');
        });
      };
      $$('.nw-nav__item--has-children', header).forEach(function (item) {
        var link = $('.nw-nav__link', item);
        item.addEventListener('mouseenter', function () { openMega(link); });
        if (link) {
          link.addEventListener('focus', function () { openMega(link); });
          link.addEventListener('keydown', function (e) {
            if (e.key === 'Escape') { closeMega(); link.blur(); }
          });
        }
      });
      mega.addEventListener('mouseenter', function () { openMega(null); });
      header.addEventListener('mouseleave', closeMega);
      document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape') closeMega();
      });
    }
  }

  /* ------------------------------------------------------------- cart drawer */
  var drawer = { el: null, overlay: null };

  function openCart() {
    if (!drawer.el) return;
    drawer.el.hidden = false;
    if (drawer.overlay) { drawer.overlay.hidden = false; }
    requestAnimationFrame(function () {
      drawer.el.classList.add('is-open');
      if (drawer.overlay) drawer.overlay.classList.add('is-open');
    });
    document.body.style.overflow = 'hidden';
    var close = $('.nw-drawer__close', drawer.el);
    if (close) close.focus();
  }

  function closeCart() {
    if (!drawer.el) return;
    drawer.el.classList.remove('is-open');
    if (drawer.overlay) drawer.overlay.classList.remove('is-open');
    document.body.style.overflow = '';
    setTimeout(function () {
      drawer.el.hidden = true;
      if (drawer.overlay) drawer.overlay.hidden = true;
    }, 340);
  }

  function refreshCart(openAfter) {
    return fetch(routes.cart + '?section_id=cart-drawer', { headers: { 'X-Requested-With': 'XMLHttpRequest' } })
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var fresh = $('[data-nw-cart-drawer]', doc);
        if (fresh && drawer.el) {
          var wasOpen = drawer.el.classList.contains('is-open');
          var parent = drawer.el.parentNode;
          fresh.hidden = drawer.el.hidden;
          if (wasOpen) fresh.classList.add('is-open');
          parent.replaceChild(fresh, drawer.el);
          drawer.el = fresh;
        }
        return fetch(routes.cart + '.js').then(function (r) { return r.json(); });
      })
      .then(function (cart) {
        $$('[data-nw-val="cartCount"]').forEach(function (n) {
          n.textContent = /\(/.test(n.textContent) ? '(' + cart.item_count + ')' : cart.item_count;
        });
        $$('[data-nw-val="cartTotal"]').forEach(function (n) { n.textContent = money(cart.total_price); });
        if (openAfter) openCart();
      })
      .catch(function () { if (openAfter) openCart(); });
  }

  function addToCart(id, qty, sellingPlan) {
    if (!id) return Promise.resolve();
    var body = { id: id, quantity: qty || 1 };
    if (sellingPlan) body.selling_plan = sellingPlan;
    return fetch(routes.cart_add, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body)
    }).then(function (r) { return r.json(); })
      .then(function (res) {
        if (res.status) { alert(res.description || res.message); return; }
        return refreshCart(true);
      });
  }

  function changeLine(key, qty) {
    return fetch(routes.cart_change, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: key, quantity: qty })
    }).then(function () { return refreshCart(false); });
  }

  /* ------------------------------------------------------------- PDP variants */
  function productForm() {
    var form = $('[data-nw-product-form]');
    if (!form) return;
    var dataEl = $('[data-nw-product-json]');
    if (!dataEl) return;
    var product;
    try { product = JSON.parse(dataEl.textContent); } catch (e) { return; }
    var idInput = $('[name="id"]', form);
    var planInput = $('[name="selling_plan"]', form);
    var selected = (product.variants || []).slice();
    var current = product.variants.filter(function (v) { return String(v.id) === String(idInput && idInput.value); })[0] || product.variants[0];
    var chosen = (current.options || []).slice();

    function findVariant() {
      return product.variants.filter(function (v) {
        return v.options.every(function (o, i) { return chosen[i] == null || o === chosen[i]; });
      })[0];
    }

    function paint() {
      var v = findVariant();
      if (!v) return;
      current = v;
      if (idInput) idInput.value = v.id;

      $$('[data-nw-val="totalLabel"]').forEach(function (n) { n.textContent = money(v.price); });
      $$('[data-nw-val="variantLabel"]').forEach(function (n) { n.textContent = v.title; });
      var cmp = v.compare_at_price && v.compare_at_price > v.price
        ? v.compare_at_price
        : Math.round(v.price * 100 / (NW.rrpRatio || 70));
      $$('[data-nw-val="compareLabel"], .nw-compare[data-nw-dynamic]').forEach(function (n) { n.textContent = money(cmp); });
      var subPct = (100 - (NW.subscribeDiscount || 20)) / 100;
      $$('[data-nw-val="unitPriceLabel"]').forEach(function (n) { n.textContent = money(Math.round(v.price * subPct)); });
      $$('[data-nw-val="unitCompareLabel"]').forEach(function (n) { n.textContent = money(cmp); });
      var weeks = parseInt(form.getAttribute('data-nw-weeks'), 10) || 16;
      $$('[data-nw-val="perDayLine"]').forEach(function (n) { n.textContent = money(Math.round(v.price / weeks)) + ' a week'; });

      $$('[data-nw-atc]').forEach(function (btn) {
        btn.disabled = !v.available;
        btn.textContent = v.available ? (btn.getAttribute('data-nw-label') || 'Add to Cart') : (NW.strings ? NW.strings.soldOut : 'Sold out');
      });
      $$('[data-nw-click="cart:add-product"][data-nw-variant]').forEach(function (b) {
        if (form.contains(b)) b.setAttribute('data-nw-variant', v.id);
      });
      if (v.featured_image && v.featured_image.src) setMainImage(v.featured_image.src);
      if (history.replaceState) {
        var u = new URL(window.location.href);
        u.searchParams.set('variant', v.id);
        history.replaceState({}, '', u.toString());
      }
    }

    $$('[data-nw-click="variant:select"]', form).forEach(function (btn) {
      btn.addEventListener('click', function () {
        var pos = parseInt(btn.getAttribute('data-nw-opt'), 10);
        var val = btn.getAttribute('data-nw-value');
        if (!pos || val == null) return;
        chosen[pos - 1] = val;
        var group = btn.parentNode;
        $$('[data-nw-click="variant:select"]', group).forEach(function (b) {
          b.classList.toggle('is-selected', b === btn);
          b.setAttribute('aria-pressed', b === btn ? 'true' : 'false');
        });
        paint();
      });
    });

    $$('[data-nw-click="plan:select"]', form).forEach(function (btn) {
      btn.addEventListener('click', function () {
        if (planInput) planInput.value = btn.getAttribute('data-nw-plan') || '';
        $$('[data-nw-click="plan:select"]', form).forEach(function (b) {
          b.classList.toggle('is-selected', b === btn);
          b.setAttribute('aria-pressed', b === btn ? 'true' : 'false');
        });
      });
    });

    form.addEventListener('submit', function (e) {
      e.preventDefault();
      addToCart(idInput && idInput.value, 1, planInput && planInput.value);
    });

    paint();
  }

  function setMainImage(src) {
    var main = $('[data-nw-main-image]');
    if (main) main.setAttribute('src', src);
  }

  function gallery() {
    $$('[data-nw-click="gallery:select"]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var src = btn.getAttribute('data-nw-src');
        if (src) setMainImage(src);
        var group = btn.parentNode;
        $$('[data-nw-click="gallery:select"]', group).forEach(function (b) {
          b.classList.toggle('is-selected', b === btn);
        });
      });
    });
  }

  /* ---------------------------------------------------------- pack selection */
  function packs() {
    $$('[data-nw-click="opt:select"]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var group = btn.parentNode;
        $$('[data-nw-click="opt:select"]', group).forEach(function (b) {
          b.classList.toggle('is-selected', b === btn);
          b.setAttribute('aria-pressed', b === btn ? 'true' : 'false');
        });
        var vid = btn.getAttribute('data-nw-variant');
        var form = $('[data-nw-product-form]');
        if (vid && form) {
          var idInput = $('[name="id"]', form);
          if (idInput) idInput.value = vid;
        }
      });
    });
  }

  /* ---------------------------------------------------------------- accordion */
  function accordions() {
    $$('[data-nw-click="acc:toggle"], [data-nw-acc-toggle]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var wrap = btn.closest('.nw-acc') || btn.parentNode;
        var open = wrap.classList.toggle('is-open');
        btn.setAttribute('aria-expanded', open ? 'true' : 'false');
        var sign = $('[data-nw-acc-sign]', wrap);
        if (sign) sign.textContent = open ? '–' : '+';
      });
    });
    $$('[data-nw-click="more:toggle"]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var t = document.getElementById(btn.getAttribute('aria-controls') || '');
        if (t) t.hidden = !t.hidden;
        btn.setAttribute('aria-expanded', t && !t.hidden ? 'true' : 'false');
      });
    });
  }

  /* ----------------------------------------------------------------- carousel */
  function carousels() {
    $$('[data-nw-carousel]').forEach(function (root) {
      var track = $('[data-nw-track]', root) || $('.nw-vid-track', root) || $('.nw-insta-track', root);
      if (!track) return;
      var i = 0;
      var step = function (d) {
        var n = track.children.length;
        if (!n) return;
        i = Math.max(0, Math.min(n - 1, i + d));
        var w = track.children[0].offsetWidth + 16;
        track.style.transform = 'translateX(' + (-i * w) + 'px)';
      };
      $$('[data-nw-click="video:next"], [data-nw-click="insta:step"][data-nw-dir="1"]', root)
        .forEach(function (b) { b.addEventListener('click', function () { step(1); }); });
      $$('[data-nw-click="video:prev"], [data-nw-click="insta:step"][data-nw-dir="-1"]', root)
        .forEach(function (b) { b.addEventListener('click', function () { step(-1); }); });
    });
  }

  /* ------------------------------------------------------------- sticky ATC */
  function stickyAtc() {
    var bar = $('[data-nw-sticky]');
    if (!bar) return;
    bar.hidden = false;
    var after = 700;
    var buy = $('#buy');
    var onScroll = function () {
      var trigger = buy ? buy.offsetTop + buy.offsetHeight : after;
      bar.classList.toggle('is-on', window.scrollY > trigger);
    };
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  }

  /* ------------------------------------------------------------------ videos */
  function videos() {
    $$('video[data-remote-src]').forEach(function (v) {
      var u = v.getAttribute('data-remote-src');
      if (u && !v.src) v.src = u;
      v.muted = true; v.defaultMuted = true; v.playsInline = true;
      v.setAttribute('playsinline', '');
      var p = v.play();
      if (p && p.catch) p.catch(function () {});
    });
  }

  /* ------------------------------------------------------------ event router */
  var handlers = {};
  function on(action, fn) { (handlers[action] = handlers[action] || []).push(fn); }

  document.addEventListener('click', function (e) {
    var el = e.target.closest('[data-nw-click]');
    if (!el) return;
    var action = el.getAttribute('data-nw-click');
    if (action === 'cart:open') { e.preventDefault(); openCart(); return; }
    if (action === 'cart:close') { e.preventDefault(); closeCart(); return; }
    if (action === 'cart:add-product') {
      e.preventDefault();
      addToCart(el.getAttribute('data-nw-variant'), 1, el.getAttribute('data-nw-plan'));
      return;
    }
    if (action === 'cart:inc' || action === 'cart:dec') {
      e.preventDefault();
      var q = parseInt(el.getAttribute('data-nw-qty'), 10) || 1;
      changeLine(el.getAttribute('data-nw-key'), action === 'cart:inc' ? q + 1 : Math.max(0, q - 1));
      return;
    }
    if (action === 'cart:remove') {
      e.preventDefault();
      changeLine(el.getAttribute('data-nw-key'), 0);
      return;
    }
    (handlers[action] || []).forEach(function (fn) { fn(el, e); });
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') closeCart();
  });

  /* ------------------------------------------------------------ account page */
  function account() {
    var login = document.getElementById('CustomerLogin');
    var recover = document.getElementById('RecoverPassword');
    if (!login || !recover) return;
    var show = function (which) {
      login.style.display = which === 'login' ? '' : 'none';
      recover.style.display = which === 'recover' ? 'block' : 'none';
    };
    on('account:recover', function () { show('recover'); });
    on('account:login', function () { show('login'); });
    if (window.location.hash === '#recover') show('recover');
  }

  /* ---------------------------------------------------------------- bootstrap */
  function init() {
    drawer.el = $('[data-nw-cart-drawer]');
    drawer.overlay = $('[data-nw-overlay]');
    if (drawer.overlay) drawer.overlay.addEventListener('click', closeCart);
    announcement();
    nav();
    productForm();
    gallery();
    packs();
    accordions();
    carousels();
    stickyAtc();
    videos();
    account();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
